'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Mentions = require('./src/Mentions');

var _Mentions2 = _interopRequireDefault(_Mentions);

var _Option = require('./src/Option');

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Mentions2['default'].Option = _Option2['default'];

exports['default'] = _Mentions2['default'];